import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import { Quote } from "@cinch-labs/design-system";
import { isSSR } from "@cinch-labs/shared-util";
import { StickyNav } from "../sticky-nav";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import sharedStyles from "../../car-reviews-v2.module.css";
import cx from "classnames";
import styles from "./review-section.module.css";
import { ChevronBackToTopIcon } from "@cinch-nx/design-system-icons";
import { Media } from "../media";
const scrollToTop = ()=>{
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
};
export const ReviewSections = ({ make , model , reviewSections , children , imageCount , placeholderImage , areVehiclesInStock  })=>{
    const reviewSectionsRef = useRef(null);
    const [windowTopScrollPosition, setWindowTopScrollPosition] = useState(0);
    const [windowBottomScrollPosition, setWindowBottomScrollPosition] = useState(0);
    const isClient = !isSSR();
    const handleScroll = ()=>{
        if (isClient) {
            const windowTopPosition = window.scrollY;
            const windowBottomPosition = window.scrollY + window.innerHeight;
            setWindowTopScrollPosition(windowTopPosition);
            setWindowBottomScrollPosition(windowBottomPosition);
        }
    };
    useEffect(()=>{
        if (isClient) {
            window.addEventListener("scroll", handleScroll, {
                passive: true
            });
            return ()=>{
                window.removeEventListener("scroll", handleScroll);
            };
        }
        return ()=>null;
    }, [
        handleScroll
    ]);
    let offsetPosition = 0;
    if (reviewSectionsRef.current) {
        const reviewSections1 = reviewSectionsRef.current.offsetTop;
        const negativeOffset = 54;
        offsetPosition = reviewSections1 - negativeOffset;
    }
    const showStickyNav = windowTopScrollPosition > offsetPosition;
    return /*#__PURE__*/ _jsxs("div", {
        ref: reviewSectionsRef,
        children: [
            isClient && showStickyNav && /*#__PURE__*/ _jsx(StickyNav, {
                make: make,
                model: model,
                windowBottomScrollPosition: windowBottomScrollPosition,
                areVehiclesInStock: areVehiclesInStock
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cx(sharedStyles.inner, sharedStyles.sectionWrapper),
                children: [
                    reviewSections.map((section)=>/*#__PURE__*/ _jsxs("section", {
                            className: styles.carSectionWrapper,
                            id: section.title.toLocaleLowerCase().replace(" ", "-"),
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: styles.title,
                                    children: section.title
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: styles.sectionsRating,
                                    children: [
                                        "Our rating: ",
                                        section.rating,
                                        "/10"
                                    ]
                                }),
                                section.image ? /*#__PURE__*/ _jsx(Media, {
                                    imageCount: imageCount,
                                    imageSrc: section.image.filename ?? placeholderImage.filename,
                                    title: section.title,
                                    alt: section.image.alt ?? ""
                                }) : null,
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.body,
                                    children: [
                                        renderWithResolver(section.body),
                                        section.quote ? /*#__PURE__*/ _jsx(Quote, {
                                            text: section.quote
                                        }) : null
                                    ]
                                })
                            ]
                        }, section.title.toLocaleLowerCase().replace(" ", "-"))),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.chevronBackToTop,
                        onClick: scrollToTop,
                        children: [
                            /*#__PURE__*/ _jsx(ChevronBackToTopIcon, {}),
                            /*#__PURE__*/ _jsx("button", {
                                className: styles.buttonBackToTop,
                                children: "Back to top"
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};
